import { Button } from "@/components/ui/button";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";
import { ChevronLeft, ChevronRight } from "lucide-react";

/**
 * Server-side pagination controls.
 * Props: page, pageSize, total, onPageChange(newPage), onPageSizeChange(newSize)
 */
export default function Pagination({ page, pageSize, total, onPageChange, onPageSizeChange }) {
  const totalPages = Math.max(1, Math.ceil(total / pageSize));
  const start = total === 0 ? 0 : (page - 1) * pageSize + 1;
  const end = Math.min(total, page * pageSize);
  return (
    <div className="flex flex-wrap items-center justify-between gap-3 px-4 py-3 border-t border-slate-200 bg-white" data-testid="pagination">
      <div className="flex items-center gap-2 text-sm text-slate-600">
        <span>Sayfa başına</span>
        <Select value={String(pageSize)} onValueChange={(v) => onPageSizeChange(parseInt(v))}>
          <SelectTrigger className="w-20 h-8" data-testid="pagination-page-size">
            <SelectValue />
          </SelectTrigger>
          <SelectContent className="bg-white">
            <SelectItem value="25">25</SelectItem>
            <SelectItem value="50">50</SelectItem>
            <SelectItem value="100">100</SelectItem>
          </SelectContent>
        </Select>
        <span className="text-slate-500">
          {start}-{end} / <span className="font-semibold text-slate-700">{total.toLocaleString("tr-TR")}</span> kayıt
        </span>
      </div>
      <div className="flex items-center gap-2">
        <Button
          variant="outline"
          size="sm"
          disabled={page <= 1}
          onClick={() => onPageChange(page - 1)}
          data-testid="pagination-prev"
        >
          <ChevronLeft size={14} className="mr-1" /> Önceki
        </Button>
        <span className="text-sm text-slate-600">
          Sayfa <span className="font-semibold text-slate-800">{page}</span> / {totalPages}
        </span>
        <Button
          variant="outline"
          size="sm"
          disabled={page >= totalPages}
          onClick={() => onPageChange(page + 1)}
          data-testid="pagination-next"
        >
          Sonraki <ChevronRight size={14} className="ml-1" />
        </Button>
      </div>
    </div>
  );
}
